export default "__VITE_ASSET__fs05tAtE__"